var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _g3, _g4, _path7, _path8, _g5, _g6, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreSocialSciences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social-science",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.046,
    height: 67.046,
    viewBox: "0 0 67.046 67.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54190",
    "data-name": "Path 54190",
    d: "M128.7,95.894l-16.1-5.073-12.169-3.835-8.178,3.135a21.588,21.588,0,1,0,41.715,10.253Z",
    transform: "translate(-79.084 -75.595)",
    fill: "#6cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54191",
    "data-name": "Path 54191",
    d: "M277.368,125.825l-5.27-4.48L256,116.272V144.39A21.593,21.593,0,0,0,277.368,125.825Z",
    transform: "translate(-222.477 -101.046)",
    fill: "#59abff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54192",
    "data-name": "Path 54192",
    d: "M120.964,0a21.713,21.713,0,0,0-20.347,14.526l8.178,4.722,1.964-3.4,5.363-1.439,3.4,1.964-1.964,3.4L119,25.14l1.964,1.132,1.443.832-1.443,3.4,8.241.527,3.928-6.806,9.2.551A21.575,21.575,0,0,0,120.964,0Z",
    transform: "translate(-87.441)",
    fill: "#9bf243"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54193",
    "data-name": "Path 54193",
    d: "M256,0V26.273l1.443.832L256,30.506l8.241.527,3.928-6.806,9.2.551A21.575,21.575,0,0,0,256,0Z",
    transform: "translate(-222.477)",
    fill: "#7dd96b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46631",
    "data-name": "Group 46631",
    transform: "translate(27.63 43.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54194",
    "data-name": "Path 54194",
    d: "M216.893,331a5.893,5.893,0,1,0,5.893,5.893A5.885,5.885,0,0,0,216.893,331Z",
    transform: "translate(-211 -331)",
    fill: "#ffd9b3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46632",
    "data-name": "Group 46632",
    transform: "translate(23.702 55.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54195",
    "data-name": "Path 54195",
    d: "M190.821,421A9.937,9.937,0,0,0,181,430.952v1.964h19.642v-1.964A9.937,9.937,0,0,0,190.821,421Z",
    transform: "translate(-181 -421)",
    fill: "#ffbe40"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54196",
    "data-name": "Path 54196",
    d: "M256,342.785V331a5.893,5.893,0,1,1,0,11.785Z",
    transform: "translate(-222.477 -287.656)",
    fill: "#fb9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54197",
    "data-name": "Path 54197",
    d: "M265.821,430.952v1.964H256V421A9.937,9.937,0,0,1,265.821,430.952Z",
    transform: "translate(-222.477 -365.87)",
    fill: "#ff9f40"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46633",
    "data-name": "Group 46633",
    transform: "translate(4.059 35.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54198",
    "data-name": "Path 54198",
    d: "M36.893,271a5.893,5.893,0,1,0,5.893,5.893A5.885,5.885,0,0,0,36.893,271Z",
    transform: "translate(-31 -271)",
    fill: "#ffd9b3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46635",
    "data-name": "Group 46635",
    transform: "translate(0 47.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46634",
    "data-name": "Group 46634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54199",
    "data-name": "Path 54199",
    d: "M9.952,361A9.937,9.937,0,0,0,0,370.821v9.952H19.773v-9.952A9.825,9.825,0,0,0,9.952,361Z",
    transform: "translate(0 -361)",
    fill: "#665252"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54200",
    "data-name": "Path 54200",
    d: "M76,282.785V271a5.893,5.893,0,0,1,0,11.785Z",
    transform: "translate(-66.048 -235.513)",
    fill: "#fb9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54201",
    "data-name": "Path 54201",
    d: "M85.821,370.821v9.952H76V361A9.825,9.825,0,0,1,85.821,370.821Z",
    transform: "translate(-66.048 -313.727)",
    fill: "#4d3636"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46636",
    "data-name": "Group 46636",
    transform: "translate(51.201 35.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54202",
    "data-name": "Path 54202",
    d: "M396.893,271a5.893,5.893,0,1,0,5.893,5.893A5.885,5.885,0,0,0,396.893,271Z",
    transform: "translate(-391 -271)",
    fill: "#ffd9b3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46637",
    "data-name": "Group 46637",
    transform: "translate(47.273 47.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54203",
    "data-name": "Path 54203",
    d: "M370.821,361A9.825,9.825,0,0,0,361,370.821v9.952h19.773v-9.952A9.937,9.937,0,0,0,370.821,361Z",
    transform: "translate(-361 -361)",
    fill: "#ff5959"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54204",
    "data-name": "Path 54204",
    d: "M436,282.785V271a5.893,5.893,0,1,1,0,11.785Z",
    transform: "translate(-378.906 -235.513)",
    fill: "#fb9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54205",
    "data-name": "Path 54205",
    d: "M445.952,370.821v9.952H436V361A9.937,9.937,0,0,1,445.952,370.821Z",
    transform: "translate(-378.906 -313.727)",
    fill: "#e63a57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreSocialSciences);
export default __webpack_public_path__ + "static/media/explore-social-sciences.2140411266cda71095125cae4008e4ea.svg";
export { ForwardRef as ReactComponent };